export const getBackofficeEndpoint = (version: number = 1) =>
  `${window.env.apis.registroPresencaApi}/v${version}`;
